import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";

const FFdesTableData = ({ data, index, currentPage }) => {
  const navigate = useNavigate();
  return (
    <tr className="table-rows1" key={index}>
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">{data.designation_id ? data.designation_id : '--'}</td>
      <td className="table-each-row-data">{data?.name ? data?.name : '--'}</td>
      <td className="table-each-row-data">{data?.order_approval_from ? `₹.${data?.order_approval_from}` : '--'}</td>
      <td className="table-each-row-data">{data?.order_approval_upto ? `₹.${data?.order_approval_upto}` : '--'}</td>
      <td className="table-each-row-data">
        {data?.fieldForceDesignationVersion?.updatedBy?.name ? data?.fieldForceDesignationVersion?.updatedBy?.name : '--'}
      </td>
      <td className="table-each-row-data">
        {data?.fieldForceDesignationVersion?.updatedAt ? moment(data?.fieldForceDesignationVersion?.updatedAt)
          .format("DD MMM YYYY, HH:MM A")
          .toUpperCase() : '--'}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() =>
              navigate(
                `/field-force/designation/version-history-detail/${data?.id}`
              )
            }
          >
            View
          </button>
        </div>
      </td>
    </tr>
  );
};

export default FFdesTableData;
